import { Loader } from 'components/Loader';
import Login from 'components/Login';
import NotFound from 'components/NotFound';
import SessionExpired from 'components/SessionExpired';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthenticatedRoutes, OIDCRedirect } from '../Auth';

const AssetListPage = lazy(() => import('containers/AssetListPage/AssetListPage'));
const BaseLayout = lazy(() => import('containers/BaseLayout/BaseLayout'));
const BrowseDataSources = lazy(() => import('containers/BrowseDataSources/BrowseDataSources'));
const ChatbotPage = lazy(() => import('containers/ChatbotPage/ChatbotPage'));
const ConversationSearch = lazy(() => import('containers/ConversationSearch/ConversationSearch'));
const WorkspaceStats = lazy(() => import('containers/CWViews/WorkspaceStats'));
const DatabaseView = lazy(() => import('containers/CWViews/DatabaseView'));
const DownloadsPage = lazy(() => import('containers/Downloads/DownloadsPage'));
const McpTokensPage = lazy(() => import('containers/McpTokens/McpTokensPage'));
const SearchResults = lazy(() => import('containers/SearchResults/SearchResults'));
const TableDetails = lazy(() => import('containers/TableDetails/TableDetails'));
const Walkthrough = lazy(() => import('containers/Walkthrough/Walkthrough'));

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<BaseLayout />} path="/">
        <Route element={<AuthenticatedRoutes />} path="/">
          <Route element={<BrowseDataSources />} index />
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <SearchResults />
              </Suspense>
            }
            path="/search"
          />
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <DownloadsPage />
              </Suspense>
            }
            path="/downloads"
          />
          <Route path="/chatbot">
            <Route
              element={
                <Suspense fallback={<Loader />}>
                  <ChatbotPage />
                </Suspense>
              }
              path="conversations?/:conversationId?"
            />
            <Route
              element={
                <Suspense fallback={<Loader />}>
                  <ConversationSearch />
                </Suspense>
              }
              path="search"
            />
          </Route>
          <Route path="/dataSource">
            <Route
              path=":dataSource"
              element={
                <Suspense fallback={<Loader />}>
                  <AssetListPage />
                </Suspense>
              }
            />
            <Route
              path=":dataSource/database/:databaseName/asset/:tableId/*"
              element={
                <Suspense fallback={<Loader />}>
                  <TableDetails />
                </Suspense>
              }
            />
          </Route>
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <Walkthrough />
              </Suspense>
            }
            path="/walkthrough"
          />
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <McpTokensPage />
              </Suspense>
            }
            path="/tokens"
          />
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <WorkspaceStats />
              </Suspense>
            }
            path="/cw_views"
          />
          <Route
            element={
              <Suspense fallback={<Loader />}>
                <DatabaseView />
              </Suspense>
            }
            path="/cw_views/workspace/:workspaceName/database/:databaseName"
          />
        </Route>
        <Route element={<NotFound />} path="*" />
        <Route element={<NotFound />} path="/notFound" />
        <Route element={<SessionExpired />} path="/session-expired" />
        <Route element={<Login />} path="/login" />
      </Route>
      <Route element={<OIDCRedirect />} path="/index.html" />
    </Routes>
  );
}
